<mat-toolbar color="primary" class="app-navbar">
  @if (backLink() !== false) {
    <button mat-icon-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
  }
  @if (backLink() === false && showMenuButton) {
    <button mat-icon-button (click)="onMenuToggle()">
      <mat-icon>menu</mat-icon>
    </button>
  }

  <div class="toolbar-content">
    @if (mobileNavbar.title$ | async; as title) {
      <span class="toolbar-title" [class.has-subtitle]="!!(mobileNavbar.subtitle$ | async)">
        <span class="toolbar-title-text">{{ title }}</span>
        @if (mobileNavbar.subtitle$ | async; as subtitle) {
          <span class="toolbar-separator">-</span>
          <span class="toolbar-subtitle-text">{{ subtitle }}</span>
        }
      </span>
    }
  </div>


</mat-toolbar>
